import axios from 'axios';

let exports = {};
exports.namespaced = true;

exports.state = () => ({
  estimates: [],
  curEstimate: null, // Текущая загруженная Смета
  loading: {
    list: 0,
    single: 0,
    create: 0,
    delete: 0
  }
});

exports.getters = {
  loadingList: state => state.loading.list != 0,
};

exports.mutations = {
  SET_LOADING_STATUS(state, action) {
    state.loading[action]++;
  },
  REMOVE_LOADING_STATUS(state, action) {
    state.loading[action]--;
  },
  SET_ESTIMATE_LIST(state, estimates) {
    state.estimates = estimates;
  },
  SET_SINGLE_ESTIMATE(state, estimate) {
    state.curEstimate = estimate;
  },
};

exports.actions = {
  // Загрузка списка смет
  async loadList({ commit }) {
    commit('SET_LOADING_STATUS', 'list');
    try {
      let res = await axios.get('api/estimates');
      commit('SET_ESTIMATE_LIST', res.data);
      return {
        message: 'Сметы успешно загружены.'
      }
    } catch(err) {
      throw err.response.data;
    } finally {
     commit('REMOVE_LOADING_STATUS', 'list'); 
    }
  },

  // Загрузка одной конкретной сметы (для Просмотра)
  async loadSingle({commit}, id) {
    commit('SET_LOADING_STATUS', 'single');
    try {
      let res = await axios.get('api/estimates/' + id);
      commit('SET_SINGLE_ESTIMATE', res.data);
      return res.data;
    } catch(err) {
      throw err.response.data;
    } finally {
     commit('REMOVE_LOADING_STATUS', 'single'); 
    }
  },

  // Создание новой Сметы (вызывается из Конструктора)
  async create({commit, dispatch}, estimate) {
    commit('SET_LOADING_STATUS', 'create');
    try {
      //console.log(estimate);
      let res = await axios.post('api/estimates', estimate);
      await dispatch('loadList');
      return res.data.id;
    } catch(err) {
      console.log(err);
      throw err.response.data;
    } finally {
     commit('REMOVE_LOADING_STATUS', 'create'); 
    }
  },

  // Обновление Сметы 
  async update({commit, dispatch}, estimate) {
    commit('SET_LOADING_STATUS', 'create');
    try {
      //console.log(estimate);
      let res = await axios.post('api/estimates', estimate);
      await dispatch('loadList');
      return res.data;
    } catch(err) {
      console.log(err);
      throw err.response.data;
    } finally {
     commit('REMOVE_LOADING_STATUS', 'create'); 
    }
  },
  
  async delete({commit, dispatch}, id) {
    commit('SET_LOADING_STATUS', 'delete');
    try {
      let res = await axios.delete('api/estimates/' + id);
      dispatch('loadList');
      return res.data;
    } catch(err) {
      throw err.response.data;
    } finally {
      commit('REMOVE_LOADING_STATUS', 'delete');
    }
  },
};

export default exports;

